import axios from 'axios'
import { getLoginURL } from '../api';
import { fetchDefaultValues } from '../slices/defaultValueSlice';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { ENC1 } from './mmg';
import { store } from './store';



export { fakeBackend };

function fakeBackend() {

  
    let realFetch = window.fetch;
    window.fetch = function (url, opts) {
        return new Promise((resolve, reject) => {

            return authenticate();
            
            function authenticate() {
                const { username, password } = body();
               
                store.dispatch(setPageLoading());
                console.log("Fake Backend");
                console.log(getLoginURL());
                console.log(getLoginURL()+'?username='+username + '&password='+ password);
                console.log(getLoginURL()+'?password='+ password + '&username='+username);
                axios.post(getLoginURL()+'?username='+username + '&password='+ encodeURIComponent(password)).then(response => {
                    console.log("response of login");
                    console.log(response);
                    store.dispatch(setPageLoadFinish());
                    console.log("fetchDefaultValues");
                    //var authUser = { username : response.data.UserName , password : response.data.Password , token : response.data.CurrentSessonId};
                    //if(response.data.Role === "CustomerPortal"){
                    //    store.dispatch(fetchDefaultValues({authUser}));
                    //}

                    if(response.data === null){
                        return error('نام کاربری یا گذرواژه اشتباه است');
                    }else{

                        console.log(response.data.Password);
                        console.log(ENC1(response.data.Password));

                        return ok({
                            id: response.data.ID,
                            password : ENC1(response.data.Password),
                            username: response.data.UserName,
                            fullname: response.data.FullName,
                            dlCode : response.data.DLCode,
                            dlTitle : response.data.DLTitle,
                            token: response.data.CurrentSessonId,
                            partyId: response.data.PartyId,
                            role : response.data.Role,
                            underControlUsers : response.data.UnderControlUsers,
                        });
                    }
                    
                }).catch(function (err) {
                    store.dispatch(setPageLoadFinish());
                    return error('نام کاربری یا گذرواژه اشتباه است');
                });
               
            }

          
            // helper functions

            function ok(body) {

                console.log("ok(body)");
                console.log(body);
                resolve({ ok: true, text: () => Promise.resolve(JSON.stringify(body)) })
            }

            function unauthorized() {
                resolve({ status: 401, text: () => Promise.resolve(JSON.stringify({ message: 'Unauthorized' })) })
            }

            function error(message) {
                resolve({ status: 400, text: () => Promise.resolve(JSON.stringify({ message })) })
            }

            function isAuthenticated() {
                return opts.headers['Authorization'] === 'Bearer fake-jwt-token';
            }

            function body() {
                return opts.body && JSON.parse(opts.body);    
            }
        });
    }
}
